export default function MySQL_LAST_INSERT_ID() {
  return (
    <div>
      <h2>MySQL_LAST_INSERT_ID</h2>    </div>
  );
}